/**
 * Function to make AJAX request to an endpoint and return result
 *
 * @param {String} method A string which indicates request type (POST, GET)
 * @param {String} endpoint A string of the endpoint URL to send the POST request
 * @param {String} authToken A string of NOVA user api key
 * @param {Object} data A JS Object that will be converted to JSON to send as request body
 */

// eslint-disable-next-line no-unused-vars
const makeAJAXRequest = (method, endpoint, data) =>
  new Promise((resolve, reject) => {
    // Basic request configuration
    const requestConfig = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Connection: 'keep-alive'
      }
    }
    // GET request may not need body
    if (data) {
      requestConfig.body = JSON.stringify(data)
    }
    // Make the request
    fetch(endpoint, requestConfig)
      .then(res => res.json())
      .then(text => resolve(text))
      .catch(err => reject(err))
  })

module.exports = makeAJAXRequest
